import type { FaireProductEntity } from "../../entity_types/product";

export const p_yz72zgsypx: FaireProductEntity = {
  token: "p_yz72zgsypx",
  type: "product",
  name: "Oatmeal & Honey Milk Bath",
  brandToken: "b_40kn3wg5wx",
  brandName: "SOAP CHERIE",
  imageUrl:
    "https://cdn.faire.com/fastly/8c35217c599f3daea246fa63f203631f1b6dc2a503d1e7bd9337aadbc39c1b79.png",
  galleryImageUrls: [],
  priceDollars: 15.5,
  description:
    "\nProduct Details: Transform your bath into a blissful, spa-like experience with our Oatmeal & Honey Milk Bath. Inspired by ancient beauty rituals, this indulgent soak is perfect for softening, hydrating, and soothing your skin. With organic oats powder as the star, each moment feels like pure luxury while the finely milled oat powder works its magic to calm irritation, reduce redness, and help soothe eczema or sunburned skin. A true at-home retreat that wraps you in comfort.\n\nScent: A cozy blend of warm honey, soft oats, and a hint of creamy sweetness.\n\nHow to Use: Sprinkle 2–3 teaspoons into your warm bath water, swirl to blend, and let the magic unfold. Soak in the calming infusion as it works to soothe dry skin, reduce redness, and provide gentle nourishment. Drift into relaxation and let your skin drink up the goodness.\n\nIngredients: Milk Powder, Avena Sativa (Oat) Kernel Flour, Manuka Honey Powder, Sodium Bicarbonate (Baking Soda), Zea Mays (Cornstarch), Fragrant Oil.\n",
  tags: [],
  msrpDollars: 31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:55.405Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
